import type { ConversationThreadId } from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ConversationThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { MetaCommentChatMessageBubble } from "../message-types/meta-comment-chat-message-bubble";
import { ChatThreadView } from "./chat-thread-view";

interface InstagramThreadViewProps {
  thread: ConversationThread;
}

export const InstagramThreadView = memo(function InstagramThreadView({
  thread,
}: InstagramThreadViewProps) {
  return (
    <ChatThreadView
      channel={thread.channel}
      renderMessage={(msg: Message, threadId: ConversationThreadId) => (
        <MetaCommentChatMessageBubble
          channel={thread.channel}
          message={msg}
          threadId={threadId}
        />
      )}
      thread={thread}
    />
  );
});
